export const formatFromToValue = (value: number, type?: string) =>
  type === 'amount' ? `$ ${formatNumber(value)}` : type === 'percentage' ? `${value}%` : value;

const formatNumber = (value: string | number) =>
  Number(Number(value).toFixed(0)).toLocaleString('en-US', {
    minimumFractionDigits: 0,
  });
